
<panel-block panel-group id="pn-format">
  <panel-item>
    <label for="prop-format">
      Format
      <property-change-detector
        :left="selectedObjectModelProperty"
        :right="selectedObjectModelProperty.publishedEquivalent"
        :properties="[['format_type', 'type'], ['min_value', 'min'], ['max_value', 'max'], ['decimal_places', 'decimal places']]"
      />
    </label>
    <a-select
      v-model.number="selectedObjectModelProperty.format_type"
      @input="updateFormatAssociatedFields"
      :options="formatTypes"
      id="prop-format"
      compress
      ref="formatTypeSelect"
    ></a-select>
  </panel-item>

  <panel-item v-if="selectedObjectModelProperty.hasPatternFormat">
    <div class="sr-only">
      <label for="formatPattern">Pattern</label>
    </div>
    <input id="formatPattern" type="text" v-model="selectedObjectModelProperty.format_pattern" placeholder="Pattern">
  </panel-item>

  <panel-item v-if="selectedObjectModelProperty.hasFormat">
    <div class="sr-only">
      <label for="format-message-text">Custom Validation Error</label>
    </div>
    <expandable-textarea
      v-model="selectedObjectModelProperty.format_message"
      id="format-message-text"
      placeholder="Custom validation error"
    ></expandable-textarea>
  </panel-item>

  <panel-item v-if="selectedObjectModelProperty.hasNumericFormat || selectedObjectModelProperty.hasCurrencyFormat">
    <min-max-input compress :model="selectedObjectModelProperty"></min-max-input>
  </panel-item>

  <panel-item v-if="selectedObjectModelProperty.hasCurrencyFormat">
    <has-decimal-places-input :model="selectedObjectModelProperty"></has-decimal-places-input>
  </panel-item>

  <panel-item v-if="selectedObjectModelProperty.hasNumericFormat">
    <decimal-count-input :model="selectedObjectModelProperty"></decimal-count-input>
  </panel-item>
</panel-block>
